export const VM_ACTION_RELOAD_TIMEOUT = 5000;
export const PASSWORD_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[=+\-^$*.[\]{}()?"!@#%&/\\,><':;|_~`]).{8,98}/;
export const COUNTRY_TO_FLAG = {
  Singapore: 'sg.png',
  Indonesia: 'id.png',
  Australia: 'flag-of-Australia.png',
  Bulgaria: 'flag-of-Bulgaria.png',
};
